module.exports = __webpack_public_path__ + "static/img/case1-bg.b0f9f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case1-bg.jpg
// module id = TrRP
// module chunks = 0